import React, { memo } from 'react';

import { IPrintPartProps } from 'store/entity/IPrintTemplatePart';
import SanitizedHTML from 'react-sanitized-html';
import { SingleTaskPart } from '../styles';

const TextPart: React.FC<IPrintPartProps<'title' | 'subTasksTitle'>> = ({
  item,
  property,
  task,
}) => {
  return (
    <SingleTaskPart style={{ display: 'flex', alignItems: 'start' }}>
      {item.part === 'title' && task && <span>{task?.taskName}: </span>}{' '}
      <SanitizedHTML style={{ display: 'inline' }} html={property!} />{' '}
    </SingleTaskPart>
  );
  // return <span>{property}</span>;
};

export default memo(TextPart)!;
